import qs from 'qs';
import request from '../index';
/** 和推送消息有关的接口 **/

/** 
* 客户端消息推送
* @params {string} data.content 消息内容
* @params {number} data.id 
* @params {string} data.toUserId 接收者
* @params {string} data.type 0：未读，1：已读
* @params {string} data.userId 发送者id
*/

/** 
* 删除推送消息
* @params {array} ids
*/
export const deletePushMessage = (data) => request.delete('/api-qc/deletePushMessage', data);

/**
* 获取推送消息列表
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {number} params.userId userId
*/
export const getPushMessageList = (params) => request.get('/api-qc/getPushMessageList', { params });

/** 
* 修改推送消息状态
* @params {客户端消息推送} pushMessage
*/
export const updatePushMessage = (data) => request.put('/api-qc/updatePushMessage', data);

